export default __webpack_public_path__ + "static/media/walking-solid.99b72f4d.svg";